import { Component, OnInit, ViewChild } from "@angular/core";
import { NgIf } from "@angular/common";

//Servicios
import { TiposEspecialistaService } from "src/app/core/services/tipo-especialista.service";
import { EspecialidadesService } from "src/app/core/services/especialidades.service";
import { EspecialistaService } from "src/app/core/services/especialista.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { SedeService } from "src/app/core/services/sede.service";
//Componentes
import { ListadoPaquetesComponent } from "../paquetes/listado-paquetes/listado-paquetes.component";
import { MisPaquetesComponent } from "../paquetes/mis-paquetes/mis-paquetes.component";
import { FormSolicitudComponent } from "../citas/form-solicitud/form-solicitud.component";
import { ProximasCitasComponent } from "../citas/proximas-citas/proximas-citas.component";
import { PagosCitasComponent } from "../citas/pagos-citas/pagos-citas.component";
import Swal from "sweetalert2";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { ConsentimientoService } from "src/app/core/services/consentimiento.service";
import { CitaService } from "src/app/core/services/cita.service";
import { TypebotService } from "src/app/core/services/bot.serevice";

// PARA REALTIME
import { ApisService } from "src/app/core/services/apis.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-dashboard",
  standalone: true,
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  imports: [
    FormSolicitudComponent,
    ProximasCitasComponent,
    ListadoPaquetesComponent,
    MisPaquetesComponent,
    NgIf,
  ],
})
/**
 *  Dashboard Component
 */
export class DashboardComponent implements OnInit {
  @ViewChild(MisPaquetesComponent) misPaquetesComponent!: MisPaquetesComponent;
  @ViewChild(ProximasCitasComponent)
  proximasCitasComponent!: ProximasCitasComponent;

  // realtime
  private realtimeSubscription: any;

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  especialistasFiltrados = [];
  tiposEspecialistas = [];
  especialidades = [];
  especialistas = [];
  convenios = [];
  servicios = [];
  sedes = [];
  showValidation: boolean = false;
  showConsentimiento: boolean = false;
  currentUser: any;

  constructor(
    private __sedeService: SedeService,
    private __serviciosService: ServiciosService,
    private __especialistasService: EspecialistaService,
    private __especialidadesService: EspecialidadesService,
    private __tiposEspecialistaService: TiposEspecialistaService,
    private __authService: AuthenticationService,
    private __citasservice: CitaService,
    private __consentimientoService: ConsentimientoService,
    private typebotService: TypebotService,
    private apisService: ApisService
  ) {}

  ngOnInit(): void {
    // Suscribirse a cambios en tiempo real
    this.setupRealtimeSubscription();

    // traer el bot
    // this.typebotService.loadTypebotScript();

    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);
      // Ejecuta validación del consentimiento
      this.getConsentimiento(this.currentUser.userId);
    }

    /**
     * BreadCrumb
     */
    this.breadCrumbItems = [
      { label: "Dashboard" },
      { label: "Dashboard", active: true },
    ];

    this.getSedes((data: any) => {
      this.sedes = data;
    });
    this.getServicios((data: any) => {
      this.servicios = data;
    });
    this.getEspecialidades((data: any) => {
      this.especialidades = data;
    });
    this.getTipoEspecialistas((data: any) => {
      this.tiposEspecialistas = data.documents;
    });

    // Ejecuta validación del usuario para su correo
    this.getValidation();
  }

  // REALTIME
  setupRealtimeSubscription(): void {
    // Crear suscripción para escuchar cambios en la colección
    this.realtimeSubscription = this.apisService.subscribe(
      [`databases.${environment.databaseName}.collections.pacientes.documents`],
      (response) => {
        // // Manejar diferentes eventos
        // if (response.events.includes(`databases.${environment.databaseName}.collections.pacientes.documents.*.create`)) {
        //   // Se ha creado un nuevo documento
        //   const newTask = response.payload;
        //   this.tasks = [...this.tasks, newTask];
        // }

        if (
          response.events.includes(
            `databases.${environment.databaseName}.collections.pacientes.documents.*.update`
          )
        ) {
          // Se ha actualizado un documento existente
          console.log("Se ha actualizado un documento PACIENTE");
          const updatedTask = response.payload;
          console.log("updatedTask:", updatedTask);
        }

        // if (
        //   response.events.includes(
        //     `databases.${environment.appwrite.databaseId}.collections.${environment.appwrite.collectionId}.documents.*.delete`
        //   )
        // ) {
        //   // Se ha eliminado un documento
        //   const deletedTaskId = response.payload.$id;
        //   this.tasks = this.tasks.filter((task) => task.$id !== deletedTaskId);
        // }
      }
    );
  }

  async getConsentimiento(idPaciente) {
    this.showConsentimiento = false;

    try {
      console.log("BUSCA CONSENTIMIENTO.");

      const retorna =
        await this.__consentimientoService.getConsentimientoConCita(idPaciente);
      this.showConsentimiento = !retorna;
      console.log("consentimiento", retorna);
      // Aquí puedes usar el valor de 'retorna'
    } catch (error) {
      this.showConsentimiento = !false;
      // console.error('Error al obtener consentimiento:', error);
    }

    if (this.showConsentimiento) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        html: `
          Aún no has llenado tu consentimiento informado!!. <br><a href="/consentimiento" class="alert-link">Click aquí para diligenciarlo</a>
        `,
        showCloseButton: true,
        showConfirmButton: false,
        timer: 10500,
      });
    }
  }

  /**
   * @getSedes()
   * @param dataComp
   */
  getSedes(dataComp: any) {
    this.__sedeService.getSedes().then((data: any) => {
      dataComp(data.documents);
    });
  }

  /**
   * @getServicios()
   * @param dataComp
   */
  getServicios(dataComp: any) {
    this.__serviciosService.getData().then((data: any) => {
      dataComp(data);
    });
  }

  /**
   * @getTipoEspecialistas()
   * @param dataComp
   */
  getTipoEspecialistas(dataComp: any) {
    this.__tiposEspecialistaService.getTiposDocumento().then((data: any) => {
      dataComp(data);
    });
  }

  /**
   * @getEspecialidades()
   * @param dataComp
   */
  getEspecialidades(dataComp: any) {
    this.__especialidadesService.getData().then((data: any) => {
      dataComp(data);
    });
  }

  getValidation() {
    this.__authService.getValidation().then((data: any) => {
      this.showValidation = !data.emailVerification;
    });
  }

  setValidation() {
    this.__authService.sendValidation().then((data: any) => {
      Swal.fire({
        icon: "success",
        title: "Revisa tu bandeja de entrada para validar tu correo",
        showConfirmButton: true,
      });
    });
  }
}
